import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #1E0D05 0%, #2A1A0E 50%, #1A100A 100%)' }}>
      {/* Top mural border */}
      <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-saffron via-turmeric via-coral via-teal to-magenta"></div>

      {/* Subtle jaali background */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,182,39,0.6) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      ></div>

      {/* Decorative side accent */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-saffron/40 via-coral/30 to-teal/40"></div>
      <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-teal/40 via-turmeric/30 to-saffron/40"></div>

      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            {/* Logo + Brand Name */}
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/19b809d9-7658-45a2-b8c9-63ddfa78d633.png"
                alt="Chaska Indian Kitchen"
                className="h-14 w-auto object-contain"
              />
              <div>
                <p className="font-serif text-white text-lg font-bold leading-tight tracking-wide uppercase">CHASKA</p>
                <p className="font-sans text-saffron text-xs tracking-[0.2em] uppercase">INDIAN KITCHEN</p>
              </div>
            </div>
            <p className="font-accent text-saffron text-lg mb-3">A craving worth coming back for</p>
            <p className="font-sans text-sm text-white/55 leading-relaxed max-w-xs mb-6">
              Bringing the vibrant soul of Indian street food and traditional flavors to Duncan, South Carolina.
            </p>

            {/* Social links */}
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
                { icon: 'ri-facebook-circle-line', href: '#', label: 'Facebook' },
                { icon: 'ri-twitter-x-line', href: '#', label: 'X (Twitter)' },
                { icon: 'ri-yelp-line', href: '#', label: 'Yelp' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/50 hover:border-saffron hover:text-saffron hover:bg-saffron/10 transition-all duration-200 cursor-pointer"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Visit Us */}
          <div>
            <h4 className="font-sans text-xs uppercase tracking-widest text-white/35 mb-6">Visit Us</h4>
            <div className="space-y-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-saffron/15 flex-shrink-0">
                  <i className="ri-map-pin-2-fill text-saffron text-sm"></i>
                </div>
                <div>
                  <p className="font-sans text-sm text-white/80">1675 E Main St, Suite B</p>
                  <p className="font-sans text-sm text-white/80">Duncan, SC 29334</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-saffron/15 flex-shrink-0">
                  <i className="ri-phone-fill text-saffron text-sm"></i>
                </div>
                <a href="tel:+18645550123" className="font-sans text-sm text-white/80 hover:text-saffron transition-colors cursor-pointer">
                  (864) 555-0123
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-saffron/15 flex-shrink-0">
                  <i className="ri-mail-fill text-saffron text-sm"></i>
                </div>
                <a href="mailto:inquiry@chaskaindiankitchen.com" className="font-sans text-sm text-white/80 hover:text-saffron transition-colors cursor-pointer break-all">
                  inquiry@chaskaindiankitchen.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-saffron/15 flex-shrink-0">
                  <i className="ri-time-fill text-saffron text-sm"></i>
                </div>
                <div className="font-sans text-sm text-white/75 space-y-1">
                  <p>Mon – Thu: 11am – 9pm</p>
                  <p>Fri – Sat: 11am – 10pm</p>
                  <p>Sunday: 12pm – 9pm</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sans text-xs uppercase tracking-widest text-white/35 mb-6">Quick Links</h4>
            <ul className="space-y-3 mb-8">
              {[
                { label: 'Home', to: '/' },
                { label: 'Our Menu', to: '/menu' },
                { label: 'Gallery', to: '/gallery' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="font-sans text-sm text-white/65 hover:text-saffron transition-colors cursor-pointer flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-saffron/0 group-hover:text-saffron/100 transition-colors"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Reserve callout */}
            <div className="p-4 rounded-2xl border border-saffron/25 bg-white/5 backdrop-blur-sm">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-phone-fill text-saffron text-lg"></i>
                <p className="font-serif text-saffron text-lg">Reserve a Table</p>
              </div>
              <p className="font-sans text-xs text-white/55 mb-3">Call us and we&apos;ll be happy to set up your table</p>
              <a
                href="tel:+18645550123"
                className="inline-flex items-center gap-2 bg-saffron text-white font-sans font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-coral transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                (864) 555-0123
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-white/35">
            &copy; 2025 Chaska Indian Kitchen · Duncan, SC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-sans text-xs text-white/35 hover:text-white/60 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="font-sans text-xs text-white/35 hover:text-white/60 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
